import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import Loader from "../components/Loader"; // adjust path if different

const ProtectedRoute = ({ children, roles: requiredRoles, action }) => {
  const location = useLocation();

  const { role: routeRole } = useParams();

  const {
    user: contextUser,
    roles: contextRoles,
    pages: contextPages,
    loading,
    ready,
  } = useAuth();

  // Wait until auth ready
  if (loading || !ready) return <Loader />;

  // ---------------------------
  // Safe load
  // ---------------------------

  const user = contextUser || JSON.parse(localStorage.getItem("user"));

  const userRoles = contextRoles?.length
    ? contextRoles
    : JSON.parse(localStorage.getItem("roles") || "[]");

  const pages = contextPages?.length
    ? contextPages
    : JSON.parse(localStorage.getItem("pages") || "[]");

  // ---------------------------
  // Not logged in
  // ---------------------------

  if (!user) return <Navigate to="/login" replace />;

  // ---------------------------
  // SUPER ADMIN FULL ACCESS
  // ---------------------------

  if (user.is_super_admin) return children;

  // ---------------------------
  // ROLE URL VALIDATION
  // ---------------------------

  const userPrimaryRole = userRoles?.[0]?.toLowerCase();

  if (routeRole && routeRole !== userPrimaryRole)
    return <Navigate to={`/${userPrimaryRole}/dashboard`} replace />;

  // ---------------------------
  // ROLE CHECK (if passed)
  // ---------------------------

  if (requiredRoles?.length) {
    const hasRole = userRoles?.some((r) =>
      requiredRoles.includes(r.toLowerCase()),
    );

    if (!hasRole) return <Navigate to="/404" replace />;
  }

  // ---------------------------
  // PAGE CHECK
  // ---------------------------

  const currentPage = pages?.find((p) =>
    location.pathname.startsWith(`/${userPrimaryRole}/page/${p.model_name}`),
  );

  // If dynamic page URL and no permission

  if (
    location.pathname.includes("/page/") &&
    (!currentPage || !currentPage.can_view)
  )
    return <Navigate to="/404" replace />;

  // ---------------------------
  // ACTION CHECK
  // ---------------------------

  if (action && currentPage) {
    const actionMap = {
      create: currentPage.can_create,

      edit: currentPage.can_edit,

      delete: currentPage.can_delete,
    };

    if (!actionMap[action]) return <Navigate to="/404" replace />;
  }

  return children;
};

export default ProtectedRoute;
